import React, {Component} from 'react';

import strings from 'strings';
import {updateStepData} from 'api';

import {
	no_numbers_trial,
	no_numbers_answers,
	nn_numbers_trial,
	nn_numbers_answers,
	no_older_version_numbers_trial,
	no_older_version_numbers_answers,
	nn_older_version_numbers_trial,
	nn_older_version_numbers_answers,
} from './assets';
import listen from 'assets/listen.png';
import AudioPlayer from 'components/AudioPlayer';
import {stopAllSounds, createHowl, playHowl} from 'utils/playSound';

import './styles.scss';
import {TYPES} from '../../constants/index';

class Trial extends Component {
	constructor(props) {
		super(props);
		const {ageGroup, testKeyType} = this.props;
		const isNormingTest =
			ageGroup >= 2 ||
			testKeyType === TYPES.ADULT_FOLLOWUP ||
			testKeyType === TYPES.YOUTH_FOLLOWUP;
		switch (strings.getLanguage()) {
			case 'nn':
				this.assets = isNormingTest
					? nn_numbers_trial
					: nn_older_version_numbers_trial;
				this.answers_stuff = isNormingTest
					? nn_numbers_answers
					: nn_older_version_numbers_answers;
				break;

			case 'no':
			default:
				this.assets = isNormingTest
					? no_numbers_trial
					: no_older_version_numbers_trial;
				this.answers_stuff = isNormingTest
					? no_numbers_answers
					: no_older_version_numbers_answers;
				break;
		}
	}
	componentWillReceiveProps(newProps) {
		if (newProps.stepData.answered && !this.props.stepData.answered) {
			this.playFeedback(newProps.currentStep, newProps.stepData.correct);
		}
	}

	componentWillUnmount() {
		this.stopSounds();
	};

	playFeedback = (task, correct) => {
		stopAllSounds(); //  prevent overlap

		let src;

		if (task === 0) {
			src = correct
				? this.answers_stuff.correct1
				: this.answers_stuff.incorrect1;
		} else if (task === 1) {
			src = correct
				? this.answers_stuff.correct2
				: this.answers_stuff.incorrect2;
		} else if (task === 2) {
			src = correct
				? this.answers_stuff.correct3
				: this.answers_stuff.incorrect3;
		}

		if (!src) return;

		const sound = createHowl({
			src,
			onend: () => {
				sound.unload(); //  prevent memory leak

				setTimeout(() => {
					updateStepData({feedbackDone: true});
				}, 2000);
			},
		});

		playHowl(sound);
	};

	stopSounds = () => {
		stopAllSounds();
	};
	render() {
		const {testKeyType, ageGroup} = this.props;
		const trialAudio = this.assets[this.props.currentStep];
		const isNormingTest =
			ageGroup >= 2 ||
			testKeyType === TYPES.ADULT_FOLLOWUP ||
			testKeyType === TYPES.YOUTH_FOLLOWUP;
		return (
			<div className="WorkingMemory">
				<img className="listen-image" src={listen} alt="" />
				<div className="WorkingMemory__trial-audio">
					<AudioPlayer
						autoplay
						inline
						playOnSourceChanged
						src={trialAudio}
					/>
				</div>
				{!isNormingTest && <p>{strings.wsn_test1}</p>}
			</div>
		);
	}
}
export default Trial;
